module.exports = __webpack_public_path__ + "media/images/cart/cart_t2-39d021b7659fbea03e52c979454ccd10.gif";